(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6603],{

/***/ 3849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ Fallback; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99603);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88375);





var Fallback = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "m-2",
        variant: "warning",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                className: "me-2",
                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faExclamationTriangle */ .eHv
            }),
            " ",
            children
        ]
    });
};


/***/ }),

/***/ 25801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ ProtectedEmail; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var ProtectedEmail = function(param) {
    var email = param.email, className = param.className;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), visible = ref[0], setVisible = ref[1];
    if (!visible) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("link-info clickable", className),
            onClick: function() {
                return setVisible(true);
            },
            children: "[CLICK TO DISCLOSE]"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: className,
        href: "mailto:".concat(email),
        children: email
    });
};


/***/ }),

/***/ 87414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ AnimatedCounter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_text_transition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75522);



var AnimatedCounter = function(param) {
    var className = param.className, clicked = param.clicked, count = param.count;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_text_transition__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: className,
        direction: clicked ? "down" : "up",
        text: count,
        springConfig: react_text_transition__WEBPACK_IMPORTED_MODULE_2__/* .presets["default"] */ .u["default"]
    });
};


/***/ }),

/***/ 71731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ NostalgiaBtn; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_free_regular_svg_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34288);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99603);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35005);
/* harmony import */ var _hooks_useSignedInClickHandler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16703);
/* harmony import */ var _atoms_AnimatedCounter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87414);









var NostalgiaBtn = function(props) {
    var clickHandler = (0,_hooks_useSignedInClickHandler__WEBPACK_IMPORTED_MODULE_2__/* .useSignedInClickHandler */ .T)();
    var variant = "light";
    if (props.clicked) {
        variant = "outline-success";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        onClick: function() {
            return clickHandler(function() {
                return props && props.onClickWithAuthHandling();
            });
        },
        variant: variant,
        size: "sm"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                className: "me-2",
                icon: props.clicked ? _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faHeart */ .m6i : _fortawesome_free_regular_svg_icons__WEBPACK_IMPORTED_MODULE_8__/* .faHeart */ .m6i,
                fixedWidth: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_AnimatedCounter__WEBPACK_IMPORTED_MODULE_3__/* .AnimatedCounter */ .f, {
                className: "d-inline",
                clicked: props.clicked,
                count: props.count
            })
        ]
    }));
};


/***/ }),

/***/ 16943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ LoadingText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36968);



var LoadingText = function(props) {
    return(// fixed height solves problem of dynamically changing height
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("d-flex flex-row justify-content-center align-items-center", props.className),
        style: {
            height: "45px"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                as: "span",
                animation: "border",
                role: "status",
                "aria-hidden": "true",
                className: "me-2"
            }),
            " Loading..."
        ]
    }));
};


/***/ }),

/***/ 16703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useSignedInClickHandler; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _appPath__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79973);
/* harmony import */ var _auth_authContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4191);



function useSignedInClickHandler() {
    var handleClick = function handleClick(onClick) {
        if (!user) {
            router.push(_appPath__WEBPACK_IMPORTED_MODULE_1__/* .AppPath.signIn */ .j.signIn(router.asPath));
            return;
        }
        onClick();
    };
    var user = (0,_auth_authContext__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .aF)().user;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    return handleClick;
}


/***/ }),

/***/ 10612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ boolProp; }
/* harmony export */ });
function boolProp(condition) {
    return condition ? 1 : undefined;
}


/***/ }),

/***/ 76603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ Post; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/errorboundary.js
var errorboundary = __webpack_require__(24975);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./main/components/contentCard/ContentCard.tsx
var ContentCard = __webpack_require__(27586);
// EXTERNAL MODULE: ./main/components/contentCard/ContentCardRichBody.tsx
var ContentCardRichBody = __webpack_require__(94522);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-regular-svg-icons/index.mjs
var free_regular_svg_icons = __webpack_require__(34288);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(99603);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(92876);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./main/components/buttons/NostalgiaBtn.tsx
var NostalgiaBtn = __webpack_require__(71731);
// EXTERNAL MODULE: ./main/services/toastService.ts
var toastService = __webpack_require__(88247);
// EXTERNAL MODULE: ./main/utils/boolProp.ts
var boolProp = __webpack_require__(10612);
// EXTERNAL MODULE: ./posts/services/postService.ts
var postService = __webpack_require__(33643);
// EXTERNAL MODULE: ./auth/authContext.ts + 1 modules
var authContext = __webpack_require__(4191);
// EXTERNAL MODULE: ./main/components/buttons/GreyTextBtn.module.scss
var GreyTextBtn_module = __webpack_require__(61341);
var GreyTextBtn_module_default = /*#__PURE__*/__webpack_require__.n(GreyTextBtn_module);
;// CONCATENATED MODULE: ./main/components/buttons/GreyTextBtn.tsx



var GreyTextBtn = function(param) {
    var className = param.className, clicked = param.clicked, onClick = param.onClick, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        onClick: function() {
            return onClick && onClick();
        },
        className: classnames_default()(className, (GreyTextBtn_module_default())["gt-btn"], "clickable-underline text-secondary", {
            "text-success": clicked
        }),
        children: children
    });
};

// EXTERNAL MODULE: ./main/components/loadingScreens/LoadingText.tsx
var LoadingText = __webpack_require__(16943);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./posts/hooks/useComments.ts





function useComments(totalCount, load, preloaded) {
    var handleAdded = function handleAdded(comment, order) {
        if (order === "asc") {
            setComments((0,_to_consumable_array/* default */.Z)(comments).concat([
                comment
            ]));
        } else {
            setComments([
                comment
            ].concat((0,_to_consumable_array/* default */.Z)(comments)));
        }
    };
    var handleDeleted = function handleDeleted(id) {
        setComments(comments.filter(function(i) {
            return i.id !== id;
        }));
    };
    var ref = (0,react.useState)(Boolean(preloaded)), skipFirstLoad = ref[0], setSkipFirstLoad = ref[1];
    var ref1 = (0,react.useState)(preloaded ? preloaded.comments : []), comments = ref1[0], setComments = ref1[1];
    var ref2 = (0,react.useState)(preloaded ? preloaded.hasMore : false), hasMore = ref2[0], setHasMore = ref2[1];
    var ref3 = (0,react.useState)(preloaded ? preloaded.comments[preloaded.comments.length - 1].id : null), lastId = ref3[0], setLastId = ref3[1];
    var ref4 = (0,react.useState)(false), isLoading = ref4[0], setIsLoading = ref4[1];
    var ref5 = (0,react.useState)(false), error = ref5[0], setError = ref5[1];
    function loadBatch() {
        return _loadBatch.apply(this, arguments);
    }
    function _loadBatch() {
        _loadBatch = (0,_async_to_generator/* default */.Z)(function() {
            var _newComments, data, response, error, newComments, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (skipFirstLoad) {
                            setSkipFirstLoad(false);
                            return [
                                2
                            ];
                        }
                        setError(false);
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            load(lastId)
                        ];
                    case 2:
                        response = _state.sent();
                        data = response.data;
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setError(true);
                        esm_exports/* captureException */.Tb(error);
                        return [
                            2
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        newComments = [];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            _loop = function() {
                                var c = _step.value;
                                if (!data.some(function(i) {
                                    return i.id === c.id;
                                })) {
                                    newComments.push(c);
                                }
                            };
                            for(_iterator = comments[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        (_newComments = newComments).push.apply(_newComments, (0,_to_consumable_array/* default */.Z)(data));
                        setComments(newComments);
                        setHasMore(data.length > 0 && totalCount > newComments.length);
                        if (data.length > 0) {
                            setLastId(data[data.length - 1].id);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _loadBatch.apply(this, arguments);
    }
    return {
        isLoading: isLoading,
        comments: comments,
        handleAdded: handleAdded,
        handleDeleted: handleDeleted,
        hasMore: hasMore,
        loadBatch: loadBatch,
        error: error
    };
}

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./appPath.ts
var appPath = __webpack_require__(79973);
// EXTERNAL MODULE: ./main/components/atoms/AnimatedCounter.tsx
var AnimatedCounter = __webpack_require__(87414);
// EXTERNAL MODULE: ./main/components/Avatar.tsx
var Avatar = __webpack_require__(55513);
// EXTERNAL MODULE: ./main/components/date/TimeAgo.tsx
var TimeAgo = __webpack_require__(74552);
// EXTERNAL MODULE: ./main/hooks/useSignedInClickHandler.ts
var useSignedInClickHandler = __webpack_require__(16703);
// EXTERNAL MODULE: ./main/hooks/useYear.ts
var useYear = __webpack_require__(29859);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 6 modules
var Modal = __webpack_require__(6212);
// EXTERNAL MODULE: ./main/components/ProtectedEmail.tsx
var ProtectedEmail = __webpack_require__(25801);
;// CONCATENATED MODULE: ./posts/modals/ReportContentModal.tsx





var ReportContentModal = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        show: props.show,
        onHide: props.onHide,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Title */.Z.Title, {
                    children: [
                        "Report ",
                        props.name
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                children: [
                    "If you think this ",
                    props.name,
                    " contains abusive content or spam, please email",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtectedEmail/* ProtectedEmail */.c, {
                        className: "fw-bold",
                        email: "support@nostwave.com"
                    }),
                    " with the following id as a ",
                    props.name,
                    " reference:",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "fw-bold",
                        children: [
                            props.name,
                            ":",
                            props.id
                        ]
                    }),
                    ".",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Thank you!"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Footer */.Z.Footer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "primary",
                    onClick: props.onHide,
                    children: "Close"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./posts/models/enums/commentReaction.ts
var CommentReaction;
(function(CommentReaction) {
    CommentReaction[CommentReaction["None"] = 0] = "None";
    CommentReaction[CommentReaction["Nostalgia"] = 1] = "Nostalgia";
    CommentReaction[CommentReaction["Like"] = 2] = "Like";
})(CommentReaction || (CommentReaction = {}));

// EXTERNAL MODULE: ./posts/components/PostComment.module.scss
var PostComment_module = __webpack_require__(72686);
var PostComment_module_default = /*#__PURE__*/__webpack_require__.n(PostComment_module);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(93024);
// EXTERNAL MODULE: ./node_modules/is-mobile/index.js
var is_mobile = __webpack_require__(63805);
var is_mobile_default = /*#__PURE__*/__webpack_require__.n(is_mobile);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Dropdown.js + 10 modules
var Dropdown = __webpack_require__(47131);
// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
// EXTERNAL MODULE: ./node_modules/react-text-transition/lib-esm/index.js + 2 modules
var lib_esm = __webpack_require__(75522);
// EXTERNAL MODULE: ./main/utils/isClientSide.ts
var isClientSide = __webpack_require__(20106);
;// CONCATENATED MODULE: ./posts/components/PostOrCommentOptionsDropdown.tsx

















// eslint-disable-next-line react/display-name
var CustomToggle = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        onClick: function(e) {
            e.preventDefault();
            props.onClick(e);
        },
        className: "clickable text-muted",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
            icon: free_solid_svg_icons/* faEllipsisH */.cNd
        })
    });
});
var copyLinkStr = "Copy link";
var PostOrCommentOptionsDropdown = function(props) {
    var handleDeleteClicked = function handleDeleteClicked() {
        setShowDeleteConfirmation(false);
        props.onDelete();
    };
    var shareToFacebook = function shareToFacebook() {
        return "https://www.facebook.com/sharer/sharer.php?app_id=".concat("714169006037383", "&u=").concat(encodeURIComponent(link));
    };
    var shareToMessenger = function shareToMessenger() {
        if ((0,isClientSide/* isClientSide */.S)() && is_mobile_default()({
            tablet: true
        })) {
            return "fb-messenger://share/?app_id=".concat("714169006037383", "&link=").concat(encodeURIComponent(link));
        }
        return "https://www.facebook.com/dialog/send?app_id=".concat("714169006037383", "&link=").concat(encodeURIComponent(link), "&redirect_uri=").concat(encodeURIComponent(link));
    };
    var shareToTwitter = function shareToTwitter() {
        return "https://twitter.com/share?text=".concat(encodeURIComponent("See this post by @" + props.username), "&url=").concat(encodeURIComponent(link));
    };
    var shareViaEmail = function shareViaEmail() {
        return "mailto:?subject=See this post by @".concat(props.username, "&body=See this post by @").concat(props.username, ": ").concat(link);
    };
    var handleLinkCopied = function handleLinkCopied() {
        setCopyLinkText("Copied!");
        if (copyLinkTextTimeout.current) {
            clearTimeout(copyLinkTextTimeout.current);
        }
        copyLinkTextTimeout.current = setTimeout(function() {
            setCopyLinkText(copyLinkStr);
        }, 1500);
    };
    var user = (0,authContext/* useUser */.aF)().user;
    var ref = (0,react.useState)(false), showDeleteConfirmation = ref[0], setShowDeleteConfirmation = ref[1];
    var ref1 = (0,react.useState)(false), showReportModal = ref1[0], setShowReportModal = ref1[1];
    var ref2 = (0,react.useState)(copyLinkStr), copyLinkText = ref2[0], setCopyLinkText = ref2[1];
    var copyLinkTextTimeout = (0,react.useRef)();
    var year = (0,useYear/* useYear */.V)();
    var link = "https://nostwave.com" + appPath/* AppPath.post */.j.post(year, props.username, props.id);
    (0,react.useEffect)(function() {
        return function() {
            if (copyLinkTextTimeout.current) {
                clearTimeout(copyLinkTextTimeout.current);
            }
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                show: showDeleteConfirmation,
                onHide: function() {
                    return setShowDeleteConfirmation(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                            children: "Confirmation required"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                        children: [
                            "Are you sure you want to delete this ",
                            props.name,
                            "?",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "You won't be able to restore it."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Footer */.Z.Footer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "outline-secondary",
                                onClick: function() {
                                    return setShowDeleteConfirmation(false);
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "primary",
                                onClick: handleDeleteClicked,
                                children: "Delete"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportContentModal, {
                id: props.id,
                name: props.name,
                show: showReportModal,
                onHide: function() {
                    return setShowReportModal(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Toggle */.Z.Toggle, {
                        as: CustomToggle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Menu */.Z.Menu, {
                        children: [
                            props.name === "post" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "dropdown-item",
                                        href: shareToFacebook(),
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                className: "me-2",
                                                fixedWidth: true,
                                                icon: free_brands_svg_icons/* faFacebook */.neY
                                            }),
                                            "Share to Facebook"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "dropdown-item",
                                        href: shareToMessenger(),
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                className: "me-2",
                                                fixedWidth: true,
                                                icon: free_brands_svg_icons/* faFacebookMessenger */.oJT
                                            }),
                                            "Share to Messenger"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "dropdown-item",
                                        href: shareToTwitter(),
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                className: "me-2",
                                                fixedWidth: true,
                                                icon: free_brands_svg_icons/* faTwitter */.mdU
                                            }),
                                            "Share to Twitter"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "dropdown-item",
                                        href: shareViaEmail(),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                className: "me-2",
                                                fixedWidth: true,
                                                icon: free_regular_svg_icons/* faEnvelope */.FU$
                                            }),
                                            "Share via Email"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CopyToClipboard, {
                                        text: link,
                                        onCopy: function() {
                                            return handleLinkCopied();
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "dropdown-item clickable",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    className: "me-2",
                                                    fixedWidth: true,
                                                    icon: free_solid_svg_icons/* faLink */.nNP
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_esm/* default */.Z, {
                                                    className: "d-inline",
                                                    text: copyLinkText,
                                                    springConfig: lib_esm/* presets.default */.u["default"]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "dropdown-item clickable",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: link,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "text-reset",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        className: "me-2",
                                                        fixedWidth: true,
                                                        icon: free_solid_svg_icons/* faShare */.zBy
                                                    }),
                                                    "Go to post"
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Divider */.Z.Divider, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Item */.Z.Item, {
                                as: "button",
                                onClick: function() {
                                    return setShowReportModal(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        className: "me-2",
                                        fixedWidth: true,
                                        icon: free_regular_svg_icons/* faFlag */.RrC
                                    }),
                                    "Report this ",
                                    props.name
                                ]
                            }),
                            user && props.onDelete && props.username === user.username && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Item */.Z.Item, {
                                as: "button",
                                className: "text-danger",
                                onClick: function() {
                                    return setShowDeleteConfirmation(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        className: "me-2",
                                        fixedWidth: true,
                                        icon: free_regular_svg_icons/* faTrashAlt */.I7k
                                    }),
                                    "Delete"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./posts/components/PostComment.tsx
























function getReaction(comment, reply, type) {
    if (reply) {
        return {
            count: reply.reaction[type].count,
            reacted: reply.reaction[type].reacted
        };
    }
    return {
        count: comment.reaction[type].count,
        reacted: comment.reaction[type].reacted
    };
}
var PostComment = function(param) {
    var children = param.children, comment = param.comment, reply = param.reply, postId = param.postId, canReply = param.canReply, onReplyClick = param.onReplyClick, onDeleted = param.onDeleted;
    var ref = (0,react.useState)(getReaction(comment, reply, "like")), like = ref[0], setLike = ref[1];
    var ref1 = (0,react.useState)(false), givingLike = ref1[0], setGivingLike = ref1[1];
    var ref2 = (0,react.useState)(false), showReportModal = ref2[0], setShowReportModal = ref2[1];
    var ref3 = (0,react.useState)(Boolean(reply ? reply.justAdded : comment.justAdded)), justAdded = ref3[0], setJustAdded = ref3[1];
    var clickHandler = (0,useSignedInClickHandler/* useSignedInClickHandler */.T)();
    var year = (0,useYear/* useYear */.V)();
    (0,react.useEffect)(function() {
        if (comment.justAdded) {
            var timeout = setTimeout(function() {
                return setJustAdded(false);
            }, 10000);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        comment.justAdded
    ]);
    if (reply && comment.id === reply.id) {
        throw new Error("Comment and reply ids cannot be the same.");
    }
    function handleReaction() {
        return _handleReaction.apply(this, arguments);
    }
    function _handleReaction() {
        _handleReaction = (0,_async_to_generator/* default */.Z)(function() {
            var previous, _tmp, reaction, _tmp1, _tmp2, data, _tmp3, _tmp4, _tmp5, _tmp6, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (givingLike) {
                            return [
                                2
                            ];
                        }
                        _tmp = {};
                        previous = (0,_object_spread/* default */.Z)(_tmp, like);
                        _tmp1 = {};
                        _tmp2 = {};
                        if (previous.reacted) {
                            setLike((_tmp1.count = previous.count - 1 || 0, _tmp1.reacted = false, _tmp1));
                            reaction = CommentReaction.None;
                        } else {
                            setLike((_tmp2.count = previous.count + 1, _tmp2.reacted = true, _tmp2));
                            reaction = CommentReaction.Like;
                        }
                        setGivingLike(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        if (!reply) return [
                            3,
                            3
                        ];
                        _tmp4 = {};
                        return [
                            4,
                            postService/* postService.changeCommentReplyReaction */.W.changeCommentReplyReaction(year, postId, comment.id, reply.id, (_tmp4.reaction = reaction, _tmp4))
                        ];
                    case 2:
                        _tmp3 = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        _tmp5 = {};
                        return [
                            4,
                            postService/* postService.changeCommentReaction */.W.changeCommentReaction(year, postId, comment.id, (_tmp5.reaction = reaction, _tmp5))
                        ];
                    case 4:
                        _tmp3 = _state.sent();
                        _state.label = 5;
                    case 5:
                        data = _tmp3.data;
                        _tmp6 = {};
                        setLike((_tmp6.count = data.like.count, _tmp6.reacted = data.like.reacted, _tmp6));
                        return [
                            3,
                            8
                        ];
                    case 6:
                        error = _state.sent();
                        setLike(previous);
                        (0,toastService/* showToast */.C)("An error occurred while changing your comment reaction.");
                        esm_exports/* captureException */.Tb(error);
                        return [
                            3,
                            8
                        ];
                    case 7:
                        setGivingLike(false);
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleReaction.apply(this, arguments);
    }
    function deleteComment() {
        return _deleteComment.apply(this, arguments);
    }
    function _deleteComment() {
        _deleteComment = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        if (!reply) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            postService/* postService.deleteCommentReply */.W.deleteCommentReply(year, postId, comment.id, reply.id)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            postService/* postService.deleteComment */.W.deleteComment(year, postId, comment.id)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        (0,toastService/* showToast */.C)("An error occurred while deleting the comment.");
                        esm_exports/* captureException */.Tb(error);
                        return [
                            2
                        ];
                    case 6:
                        onDeleted();
                        return [
                            2
                        ];
                }
            });
        });
        return _deleteComment.apply(this, arguments);
    }
    var thisComment = reply ? reply : comment;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportContentModal, {
                id: thisComment.id,
                name: "comment",
                show: showReportModal,
                onHide: function() {
                    return setShowReportModal(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                onClick: function() {
                    return setJustAdded(false);
                },
                className: classnames_default()((PostComment_module_default())["post-comment"], "d-flex mt-4", {
                    "border-start border-primary": justAdded
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                        className: "mt-2",
                        src: thisComment.author.avatarUrl,
                        size: "small",
                        username: thisComment.author.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ms-2 w-100",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "py-2 px-3 rounded bg-light",
                                style: {
                                    maxWidth: "max-content"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex flex-row justify-content-between align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: appPath/* AppPath.userProfile */.j.userProfile(year, thisComment.author.username),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "fw-bold me-4",
                                                    children: thisComment.author.username
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostOrCommentOptionsDropdown, {
                                                id: thisComment.id,
                                                name: "comment",
                                                username: thisComment.author.username,
                                                onDelete: deleteComment
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-1 text-multiline",
                                        children: thisComment.text
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((PostComment_module_default())["comment-buttons"], " d-flex mt-1 bullets text-secondary"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: classnames_default()({
                                            clickable: !givingLike
                                        }),
                                        onClick: function() {
                                            return clickHandler(handleReaction);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                className: classnames_default()({
                                                    "text-primary": like.reacted
                                                }, "me-1"),
                                                icon: like.reacted ? free_solid_svg_icons/* faThumbsUp */.u8Q : free_regular_svg_icons/* faThumbsUp */.u8Q,
                                                fixedWidth: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedCounter/* AnimatedCounter */.f, {
                                                className: "d-inline",
                                                clicked: like.reacted,
                                                count: like.count
                                            })
                                        ]
                                    }),
                                    canReply && /*#__PURE__*/ (0,jsx_runtime.jsx)(GreyTextBtn, {
                                        onClick: function() {
                                            return clickHandler(onReplyClick);
                                        },
                                        children: "Reply"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeAgo/* TimeAgo */.b, {
                                        date: thisComment.publishedAt
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: children
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./posts/components/PostCommentWithReplies.module.scss
var PostCommentWithReplies_module = __webpack_require__(89430);
var PostCommentWithReplies_module_default = /*#__PURE__*/__webpack_require__.n(PostCommentWithReplies_module);
// EXTERNAL MODULE: ./posts/components/SomethingWentWrong.tsx
var SomethingWentWrong = __webpack_require__(75946);
// EXTERNAL MODULE: ./main/components/Fallback.tsx
var Fallback = __webpack_require__(3849);
// EXTERNAL MODULE: ./main/language-helpers/errorMessages.ts
var errorMessages = __webpack_require__(26828);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js + 3 modules
var react_textarea_autosize_browser_esm = __webpack_require__(93463);
// EXTERNAL MODULE: ./main/components/TextLimitCounter.tsx
var TextLimitCounter = __webpack_require__(37538);
// EXTERNAL MODULE: ./main/utils/globalConst.ts
var globalConst = __webpack_require__(52806);
;// CONCATENATED MODULE: ./posts/components/CommentOrReply.tsx









var CommentOrReply = function(props) {
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === "Enter" && !e.shiftKey && props.value.trim().length > 0) {
            e.preventDefault();
            props.onPublish();
        }
    };
    var user = (0,authContext/* useUser */.aF)().user;
    var year = (0,useYear/* useYear */.V)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: props.className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginTop: "3px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                            src: user.avatarUrls[year],
                            size: "small",
                            username: user.username
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_textarea_autosize_browser_esm/* default */.Z, {
                        autoFocus: props.focus,
                        onChange: function(e) {
                            return props.onChange(e.currentTarget.value);
                        },
                        onKeyDown: function(e) {
                            return handleKeyDown(e);
                        },
                        value: props.value,
                        className: "form-control w-100 ms-2",
                        maxLength: globalConst/* POST_COMMENT_MAX_LENGTH */.lq,
                        style: {
                            resize: "none"
                        },
                        placeholder: "Write a ".concat(props.type, "..."),
                        disabled: props.isBusy,
                        minRows: 1,
                        maxRows: 10
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-flex justify-content-between mt-1",
                children: [
                    props.isBusy && /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                as: "span",
                                animation: "border",
                                size: "sm",
                                role: "status",
                                "aria-hidden": "true",
                                className: "me-1"
                            }),
                            " We are publishing your ",
                            props.type,
                            "..."
                        ]
                    }),
                    !props.isBusy && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                        className: "mt-1",
                        children: "Press Enter to post."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLimitCounter/* TextLimitCounter */.D, {
                        count: props.value.length,
                        limit: globalConst/* POST_COMMENT_MAX_LENGTH */.lq
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./posts/components/WriteReply.tsx











var WriteReply = function(props) {
    var ref = (0,react.useState)(""), text = ref[0], setText = ref[1];
    var ref1 = (0,react.useState)(false), isBusy = ref1[0], setIsBusy = ref1[1];
    function publish() {
        return _publish.apply(this, arguments);
    }
    function _publish() {
        _publish = (0,_async_to_generator/* default */.Z)(function() {
            var published, data, _tmp, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsBusy(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        _tmp = {};
                        return [
                            4,
                            postService/* postService.replyToComment */.W.replyToComment(props.post.epochStartingYear, props.post.id, props.comment.id, (_tmp.text = text, _tmp))
                        ];
                    case 2:
                        data = _state.sent().data;
                        published = data;
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        (0,toastService/* showToast */.C)(errorMessages/* CommonErrorMsg.occurredTryLater */.q.occurredTryLater);
                        esm_exports/* captureException */.Tb(error);
                        return [
                            2
                        ];
                    case 4:
                        setIsBusy(false);
                        return [
                            7
                        ];
                    case 5:
                        if (props.onPublished) {
                            props.onPublished(published);
                        }
                        setText("");
                        return [
                            2
                        ];
                }
            });
        });
        return _publish.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentOrReply, {
        className: props.className,
        value: text,
        onChange: setText,
        type: "reply",
        focus: props.focus,
        isBusy: isBusy,
        onPublish: publish
    });
};
WriteReply = (0,errorboundary/* withErrorBoundary */.Pf)(WriteReply, {
    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fallback/* Fallback */.N, {
        children: "Writing replies is temporarily unavailable."
    })
});


;// CONCATENATED MODULE: ./posts/components/PostCommentWithReplies.tsx














var PostCommentWithReplies = function(param) {
    var post = param.post, comment = param.comment, onDeleted = param.onDeleted;
    var handleReplyClicked = function handleReplyClicked() {
        setFocus(true);
        setShowReplies(true);
        loadBatch();
    };
    var handleRepliesBtnClick = function handleRepliesBtnClick() {
        setShowReplies(true);
        loadBatch();
    };
    var handleReplyDeleted = function handleReplyDeleted(id) {
        var nextReplyCount = replyCount - 1 || 0;
        setReplyCount(nextReplyCount);
        if (!nextReplyCount) {
            setShowReplies(false);
        }
        handleDeleted(id);
    };
    var ref = (0,react.useState)(false), showReplies = ref[0], setShowReplies = ref[1];
    var ref1 = (0,react.useState)(false), focus = ref1[0], setFocus = ref1[1];
    var user = (0,authContext/* useUser */.aF)().user;
    var ref2 = (0,react.useState)(comment.replyCount || 0), replyCount = ref2[0], setReplyCount = ref2[1]; // TODO refactor with React Context or Zustand
    var ref3 = useComments(comment.replyCount, function(lastId) {
        return postService/* postService.getCommentReplies */.W.getCommentReplies(post.epochStartingYear, post.id, comment.id, lastId);
    }), isLoading = ref3.isLoading, replies = ref3.comments, handleAdded = ref3.handleAdded, handleDeleted = ref3.handleDeleted, hasMore = ref3.hasMore, loadBatch = ref3.loadBatch, error = ref3.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostComment, {
        postId: post.id,
        comment: comment,
        canReply: true,
        onReplyClick: handleReplyClicked,
        onDeleted: onDeleted,
        children: [
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(SomethingWentWrong/* SomethingWentWrong */.D, {
                className: "mx-4",
                variant: "light",
                onTryAgain: loadBatch
            }),
            !error && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    !isLoading && replies.length === 0 && replyCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-2 ms-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GreyTextBtn, {
                            onClick: handleRepliesBtnClick,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faLevelUpAlt */.TX0,
                                    className: "me-2",
                                    style: {
                                        transform: "rotate(90deg)"
                                    }
                                }),
                                replyCount,
                                " ",
                                replyCount === 1 ? "Reply" : "Replies"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PostCommentWithReplies_module_default())["post-comment-replies"],
                        children: replies.map(function(r) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostComment, {
                                postId: post.id,
                                comment: comment,
                                reply: r,
                                onDeleted: function() {
                                    return handleReplyDeleted(r.id);
                                }
                            }, "reply:" + r.id);
                        })
                    }),
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* LoadingText */.g, {
                        className: "fade-in"
                    }),
                    !isLoading && showReplies && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            hasMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GreyTextBtn, {
                                    onClick: loadBatch,
                                    children: "View more replies"
                                })
                            }),
                            user && /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteReply, {
                                className: "mt-3",
                                focus: focus,
                                post: post,
                                comment: comment,
                                onPublished: function(i) {
                                    return handleAdded(i, "asc");
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
PostCommentWithReplies = (0,errorboundary/* withErrorBoundary */.Pf)(PostCommentWithReplies, {
    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(SomethingWentWrong/* SomethingWentWrong */.D, {
        className: "mx-4",
        variant: "light",
        text: "An error occurred while displaying this comment."
    })
});


;// CONCATENATED MODULE: ./posts/components/WriteComment.tsx











var WriteComment = function(props) {
    var ref = (0,react.useState)(""), text = ref[0], setText = ref[1];
    var ref1 = (0,react.useState)(false), isBusy = ref1[0], setIsBusy = ref1[1];
    function publish() {
        return _publish.apply(this, arguments);
    }
    function _publish() {
        _publish = (0,_async_to_generator/* default */.Z)(function() {
            var published, data, _tmp, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsBusy(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        _tmp = {};
                        return [
                            4,
                            postService/* postService.createComment */.W.createComment(props.post.epochStartingYear, props.post.id, (_tmp.text = text, _tmp))
                        ];
                    case 2:
                        data = _state.sent().data;
                        published = data;
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        (0,toastService/* showToast */.C)(errorMessages/* CommonErrorMsg.occurredTryLater */.q.occurredTryLater);
                        esm_exports/* captureException */.Tb(error);
                        return [
                            2
                        ];
                    case 4:
                        setIsBusy(false);
                        return [
                            7
                        ];
                    case 5:
                        if (props.onPublished) {
                            props.onPublished(published);
                        }
                        setText("");
                        return [
                            2
                        ];
                }
            });
        });
        return _publish.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentOrReply, {
        className: props.className,
        value: text,
        onChange: setText,
        type: "comment",
        focus: props.focus,
        isBusy: isBusy,
        onPublish: publish
    });
};
WriteComment = (0,errorboundary/* withErrorBoundary */.Pf)(WriteComment, {
    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fallback/* Fallback */.N, {
        children: "Writing comments is temporarily unavailable."
    })
});


;// CONCATENATED MODULE: ./posts/components/PostCommentList.tsx











var PostCommentList = function(props) {
    var handlePublished = function handlePublished(comment) {
        var view = comment;
        view.justAdded = true;
        handleAdded(comment, "desc");
        props.onPublished();
    };
    var handleDeletedPost = function handleDeletedPost(id) {
        handleDeleted(id);
        props.onDeleted();
    };
    var ref = useComments(props.post.commentsCount, function(lastId) {
        return postService/* postService.getComments */.W.getComments(props.post.epochStartingYear, props.post.id, lastId);
    }, props.preloaded), isLoading = ref.isLoading, comments = ref.comments, handleAdded = ref.handleAdded, handleDeleted = ref.handleDeleted, hasMore = ref.hasMore, loadBatch = ref.loadBatch, error = ref.error;
    var user = (0,authContext/* useUser */.aF)().user;
    (0,react.useEffect)(function() {
        return loadBatch();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-3",
                children: [
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(SomethingWentWrong/* SomethingWentWrong */.D, {
                        className: "mx-4",
                        variant: "light",
                        onTryAgain: loadBatch
                    }),
                    !error && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            user && /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteComment, {
                                className: "card-body-padding-x mt-3",
                                post: props.post,
                                onPublished: handlePublished,
                                focus: props.focusWriteInput
                            }),
                            comments.map(function(i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCommentWithReplies, {
                                    post: props.post,
                                    comment: i,
                                    onDeleted: function() {
                                        return handleDeletedPost(i.id);
                                    }
                                }, "comment:" + i.id);
                            }),
                            !user && !isLoading && comments.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "px-4 text-secondary",
                                children: "No comments yet..."
                            }),
                            hasMore && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-4 mt-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GreyTextBtn, {
                                    onClick: loadBatch,
                                    children: "View more comments"
                                })
                            }),
                            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* LoadingText */.g, {
                                className: "fade-in"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
PostCommentList = (0,errorboundary/* withErrorBoundary */.Pf)(PostCommentList, {
    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(SomethingWentWrong/* SomethingWentWrong */.D, {
        className: "mx-4",
        variant: "light",
        text: "An error occurred while displaying comments."
    })
});


;// CONCATENATED MODULE: ./posts/components/PostFooter.tsx














var PostFooter = function(param) {
    var post = param.post, preloadedComments = param.preloadedComments, onDeleted = param.onDeleted;
    var ref = (0,react.useState)(Boolean(preloadedComments)), commentsVisible = ref[0], setCommentsVisible = ref[1];
    var ref1 = (0,react.useState)(false), givingNostalgia = ref1[0], setGivingNostalgia = ref1[1];
    var ref2 = (0,react.useState)(post.nostalgiaReaction), nostalgiaReaction = ref2[0], setNostalgiaReaction = ref2[1];
    var ref3 = (0,react.useState)(post.nostalgiaCount), nostalgiaCount = ref3[0], setNostalgiaCount = ref3[1];
    var ref4 = (0,react.useState)(0), addedComments = ref4[0], setAddedComments = ref4[1]; // TODO use shared context to directly modify post state
    var ref5 = (0,react.useState)(0), deletedComments = ref5[0], setDeletedComments = ref5[1];
    function changeNostalgiaReaction() {
        return _changeNostalgiaReaction.apply(this, arguments);
    }
    function _changeNostalgiaReaction() {
        _changeNostalgiaReaction = (0,_async_to_generator/* default */.Z)(function() {
            var previous, _tmp, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        previous = (_tmp.count = nostalgiaCount, _tmp.reaction = nostalgiaReaction, _tmp);
                        setNostalgiaReaction(!previous.reaction);
                        if (previous.reaction) {
                            setNostalgiaCount(previous.count - 1 || 0);
                        } else {
                            setNostalgiaCount(previous.count + 1);
                        }
                        setGivingNostalgia(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            postService/* postService.changeNostalgiaReaction */.W.changeNostalgiaReaction(post.epochStartingYear, post.id)
                        ];
                    case 2:
                        data = _state.sent().data;
                        setNostalgiaReaction(data.value);
                        setNostalgiaCount(data.count);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setNostalgiaReaction(previous.reaction);
                        setNostalgiaCount(previous.count);
                        (0,toastService/* showToast */.C)("An error occurred while changing your post reaction.");
                        esm_exports/* captureException */.Tb(error);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setGivingNostalgia(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return _changeNostalgiaReaction.apply(this, arguments);
    }
    function deletePost() {
        return _deletePost.apply(this, arguments);
    }
    function _deletePost() {
        _deletePost = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            postService/* postService.delete */.W["delete"](post.epochStartingYear, post.id)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        (0,toastService/* showToast */.C)("An error occurred while deleting the post.");
                        esm_exports/* captureException */.Tb(error);
                        return [
                            2
                        ];
                    case 3:
                        onDeleted();
                        return [
                            2
                        ];
                }
            });
        });
        return _deletePost.apply(this, arguments);
    }
    // TODO refactor deleting operation with React Context or Zustand
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-flex justify-content-between mb-3 card-body-margin-x",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NostalgiaBtn/* NostalgiaBtn */.E, {
                                disabled: (0,boolProp/* boolProp */.g)(givingNostalgia),
                                onClickWithAuthHandling: changeNostalgiaReaction,
                                clicked: (0,boolProp/* boolProp */.g)(nostalgiaReaction),
                                count: nostalgiaCount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                onClick: function() {
                                    return setCommentsVisible(function(v) {
                                        return !v;
                                    });
                                },
                                variant: "light",
                                size: "sm",
                                className: "ms-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_regular_svg_icons/* faComment */.Mzg,
                                        fixedWidth: true,
                                        className: "me-2"
                                    }),
                                    post.commentsCount + addedComments - deletedComments
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostOrCommentOptionsDropdown, {
                        id: post.id,
                        name: "post",
                        username: post.author.username,
                        onDelete: onDeleted && deletePost
                    })
                ]
            }),
            commentsVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCommentList, {
                post: post,
                preloaded: preloadedComments,
                onPublished: function() {
                    return setAddedComments(addedComments + 1);
                },
                onDeleted: function() {
                    return setDeletedComments(deletedComments + 1);
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./posts/components/PostHeader.tsx
var PostHeader = __webpack_require__(41914);
;// CONCATENATED MODULE: ./posts/components/Post.tsx









var Post = function(param) {
    var post = param.post, preloadedComments = param.preloadedComments, onDeleted = param.onDeleted, hideFooter = param.hideFooter;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentCard/* ContentCard */.u, {
        className: classnames_default()({
            "pb-4": hideFooter
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostHeader/* PostHeader */.m, {
                post: post
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCardRichBody/* ContentCardRichBody */.q, {
                content: post.content
            }),
            !hideFooter && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    ((ref = post.content) === null || ref === void 0 ? void 0 : ref.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostFooter, {
                        post: post,
                        preloadedComments: preloadedComments,
                        onDeleted: onDeleted
                    })
                ]
            })
        ]
    });
};
Post = (0,errorboundary/* withErrorBoundary */.Pf)(Post, {
    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(SomethingWentWrong/* SomethingWentWrong */.D, {
        variant: "white",
        text: "An error occurred while displaying this post."
    })
});



/***/ }),

/***/ 75946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ SomethingWentWrong; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99603);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35005);
/* harmony import */ var _main_language_helpers_errorMessages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26828);
/* harmony import */ var _SomethingWentWrong_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98409);
/* harmony import */ var _SomethingWentWrong_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_SomethingWentWrong_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var SomethingWentWrong = function(param) {
    var className = param.className, variant = param.variant, text = param.text, onTryAgain = param.onTryAgain;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("my-2 p-4 rounded text-center", {
            "bg-white": variant === "white"
        }, {
            "bg-light": variant === "light"
        }, className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faCogs */ .Kb6,
                className: (_SomethingWentWrong_module_scss__WEBPACK_IMPORTED_MODULE_5___default().icon)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_SomethingWentWrong_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header), " fw-bold mt-2 mb-1"),
                children: "Something Went Wrong"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: text || _main_language_helpers_errorMessages__WEBPACK_IMPORTED_MODULE_3__/* .CommonErrorMsg.occurredTryLater */ .q.occurredTryLater
            }),
            onTryAgain && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                onClick: onTryAgain,
                variant: "secondary",
                className: "mt-3",
                children: "Try again"
            })
        ]
    });
};


/***/ }),

/***/ 61341:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gt-btn":"GreyTextBtn_gt-btn__Xnk5h"};

/***/ }),

/***/ 72686:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"post-comment":"PostComment_post-comment__RW_ip","comment-buttons":"PostComment_comment-buttons__Ry0Ui","border-left":"PostComment_border-left__GVdzy"};

/***/ }),

/***/ 89430:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"post-comment-replies":"PostCommentWithReplies_post-comment-replies__vBwTE"};

/***/ }),

/***/ 98409:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"SomethingWentWrong_icon__uTCp_","header":"SomethingWentWrong_header__V4WlV"};

/***/ })

}]);